var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "example",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 border-b",
    attrs: {
      "flat": "",
      "density": "compact",
      "height": "48px"
    }
  }, [_c('v-slide-group', {
    staticClass: "flex-grow-1"
  }, [_vm._t("toolbar")], 2), _c('v-btn', {
    staticClass: "text-medium-emphasis",
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.editable = !_vm.editable;
      }
    }
  }, [_c('i', {
    staticClass: "mdi-chevron-up mdi v-icon v-icon--size-default",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _c('v-divider'), _c('v-layout', [_c('v-main', {
    staticClass: "pa-8"
  }, [_c('v-sheet', {
    staticClass: "d-flex align-center",
    attrs: {
      "min-height": "300px"
    }
  }, [_c('div', {
    staticClass: "flex-fill"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._t("render")], 2)])])], 1)], 1), _vm.editable ? [_c('v-divider'), _c('v-card-text', [_vm._t("editor")], 2)] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }